const DESIGN_OPTION_STORAGE_PREFIX = "tf.designOptionId.";
export const DESIGN_OPTION_CHANGED_EVENT = "tf-design-option-changed";

export const getStoredDesignOptionId = (
  workspaceId?: string | null
): string | undefined => {
  if (!workspaceId || typeof sessionStorage === "undefined") {
    return undefined;
  }
  return (
    sessionStorage.getItem(`${DESIGN_OPTION_STORAGE_PREFIX}${workspaceId}`) ??
    undefined
  );
};

export const setStoredDesignOptionId = (
  workspaceId: string | null | undefined,
  optionId?: string | null
): void => {
  if (!workspaceId || typeof sessionStorage === "undefined") {
    return;
  }
  const key = `${DESIGN_OPTION_STORAGE_PREFIX}${workspaceId}`;
  if (optionId) {
    sessionStorage.setItem(key, optionId);
  } else {
    sessionStorage.removeItem(key);
  }
  if (typeof window !== "undefined") {
    window.dispatchEvent(new Event(DESIGN_OPTION_CHANGED_EVENT));
  }
};
